import React from "react";
import {Outlet} from "react-router-dom";
import PublicNavbar from "../../../components/publicNavbar/PublicNavbar";

import styles from "./PublicRouteLayout.module.scss";

export default function PublicRouteLayout() {
  return (
    <div className={styles.screen}>
      <PublicNavbar />
      <Outlet />
    </div>
  );
}
